/* eslint-disable no-restricted-properties */

window.dataLayer = window.dataLayer || [];

export namespace DataLayer {
    /**
     * Push data to dataLayer immediately
     *
     * Use this when the push trigger also redirects to another page
     */
    export function pushInstant(...args: any[]) {
        window.dataLayer.push(...args);
    }

    /**
     * Push data to dataLayer with a minimal delay
     */
    export function push(...args: any[]) {
        setTimeout(() => {
            pushInstant(...args);
        }, 0);
    }
}
